import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'
import {
  ChipScale,
  getSiteRFPPhaseLabel,
  SiteRFPPhaseOption,
} from 'components/helpers/getSiteRFPPhaseLabel'

export const SiteRFPPhaseChip: FunctionComponent<SiteRFPPhaseChipProps> = ({
  phase,
  scale = 'medium',
}) => {
  return (
    <Chip
      label={getSiteRFPPhaseLabel(phase, scale)}
      sx={{
        ...PHASE_COLORS[phase],
        ...SCALE_SX[scale],
        fontSize: '14px',
        '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px' },
      }}
    />
  )
}

const PHASE_COLORS: Record<
  SiteRFPPhaseOption,
  { color: string; backgroundColor: string }
> = {
  ['preRFP']: {
    color: '#384450',
    backgroundColor: '#D3E5EB',
  },
  ['rfp']: {
    color: '#760961',
    backgroundColor: '#EDBADC',
  },
  ['contracts']: {
    color: '#1A237E',
    backgroundColor: '#BFC7FF',
  },
  ['derisking']: {
    color: '#004D40',
    backgroundColor: '#9FF1DE',
  },
  ['permits']: {
    color: '#311B92',
    backgroundColor: '#D1C4E9',
  },
  ['ntp']: {
    color: '#0D47A1',
    backgroundColor: '#BBDEFB',
  },
  ['preCon']: {
    color: '#BF360C',
    backgroundColor: '#FFCCBC',
  },
  ['construction']: {
    color: '#1B5E20',
    backgroundColor: '#B9F6CA',
  },
  ['complete']: {
    color: '#285C80',
    backgroundColor: '#B9E6F0',
  },
}

const SCALE_SX: Record<ChipScale, { height: string; padding: string }> = {
  medium: {
    height: '32px',
    padding: '4px',
  },
  small: {
    height: '24px',
    padding: '3px 4px',
  },
}

interface SiteRFPPhaseChipProps {
  phase: SiteRFPPhaseOption
  scale?: ChipScale
}
